<template>
  <div class="btnModalRRIM">
    <ButtonAdd v-if="autho === true" @click.prevent="click_vmodal"
      ><img src="../../../static/icons/+.svg" alt=""> <h3 class="buttonsubtittle">Nova RRIM</h3>
    </ButtonAdd>
    <div v-if="vmodal">
      <transition name="modal-fade">
        <!-- <form @submit.prevent="submitForm"> -->
        <div class="modal_mask" @keydown.enter.stop>
          <div class="blurringbackground" :class = "{'show': vmodal}">
          </div>
          
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Cadastro de RRIM</h4> 
                  <button @click="finish_modal" class="close_button">
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-body">

              <div class="tab-content">
                <div v-show="rrim">
                  <RRIM
                    :configInputs="0"
                    @setObjOfInforGeral="getObjOfInforGeral"    
                    @setListPro="getListPro"                 
                    @setObjMoldeFechado="getObjMoldeFechado"        
                    @setObjMoldeAberto="getObjMoldeAberto"                 
                  />
                </div>

                <div class="fotos" v-show="$store.state.formPage == 4 || $store.state.formPage == 5 || $store.state.formPage == 6">
                  <FOTOS :configInputs="0" @SendDataImages="getObjAllImages" />
                </div>

                <div v-show="$store.state.formPage == 7">
                  <LSP :configInputs="0" />
                </div>
              </div>
            </div>
            <div class="modal-footer" v-show="$store.state.formPage < 7">
              <buttonVariant
                type="button"
                variant="border"
                @click="decrementPage"
                data-dismiss="modal"
                v-if="$store.state.formPage>0"
              >
                voltar
              </buttonVariant>
              <buttonVariant
                @click.prevent="incrementPage"
                type="submit"
                variant="shortwidth"
              >
                continuar
              </buttonVariant>
            </div>
            <div class="modal-footer" v-show="$store.state.formPage ==7">
              <buttonVariant
                type="button"
                variant="border"
                @click="decrementPage"
                data-dismiss="modal"
              >
                voltar
              </buttonVariant>
              <buttonVariant
                @click.prevent="submitForm"
                type="submit"
                variant="shortwidth"
              >
                Finalizar
              </buttonVariant>
            </div>
          </div>
        </div>
        <!-- </form> -->
      </transition>
    </div>
  </div>
</template>


<script>
import ButtonAdd from "../../../components/Button/Button_M1.vue";
import RRIM from "./Modules/RRIM/Layout.vue";
import FOTOS from "./Modules/FOTOSRRIM/Layout.vue";
import LSP from "./Modules/LSP/Layout.vue";
import { PostDataAllRRIM } from "../../../controllers/RRIM/PostDataAllRRIM";
import { PostImagesRRIM } from "../../../controllers/RRIM/PostImagesRRIM";
import { PostDataImagesLspRRIM } from "../../../controllers/RRIM/PostDataImagesLspRRIM";
import useVuelidate from "@vuelidate/core";
import buttonVariant from "./../../Button/Button_variants.vue";
import InformacaoGerais from "./Modules/RRIM/Modules/Informacao-Gerais.vue";


export default {
  components: {
    RRIM,
    FOTOS,
    LSP,
    ButtonAdd,
    buttonVariant
  },
  props: ["role"],
  setup() {
    return { v$: useVuelidate() };
  },
  mounted() {
    document.body.classList.remove('sc');
    if (this.role === "eng_analista" || this.role === "eng_admin") {
      this.autho = true;
    }
  },
  data() {
    return {
      autho: true,
      rrim: true,
      fotos: false,
      lsp: true,
      teste: false,
      checklist: null,

      dados: {
        InforGeral: Object,
        Produtos: Object,
        Molde_Fechado: Object,
        Molde_Aberto: Object,
      },
      dadosImages: Object,
      DataInformationDB: {
        IGDTM: "",
        IGDAM: "",
        IGDCM: "",
        IGFM: "",
        IGCMC: "",
        IGCCF: "",
        IGENF: "",
        IGNF: "",
        IGCliente: "",
        IGMolde: "",
        IGRRIM: "",
      },
      vmodal: false,
      imagetest: null, 
    };
  },

  methods: {
    async click_close_modal() {
      
      const toast = await this.$swal
        .fire({
          title: "Deseja cancelar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }
      document.body.classList.remove('sc');
      this.$store.commit("setHiddenBar", false);
      this.vmodal = false;
    },
    click_rrim() {
      this.rrim = true;
      this.fotos = false;
      this.lsp = false;
    },

    click_fotos() {
      this.rrim = false;
      this.fotos = true;
      this.lsp = false;
    },

    click_lsp() {
      this.rrim = false;
      this.fotos = false;
      this.lsp = true;
    },

    finish_modal() {
      this.$store.commit("setHiddenBar", false);
      this.$store.commit('setPadding', '2rem');
      this.$store.commit("SetFormPage", 0); 
      this.vmodal = false; 
      if (!this.modal) {
        document.body.classList.remove('sc');
      }
    },

    getObjOfInforGeral(val) {
      this.dados.InforGeral = val;
    },

    getListPro(val) {
      this.dados.Produtos = val;
    },

    getObjAllImages(val) {
      this.dadosImages = val;
    },

    getObjMoldeFechado(val) {
      this.dados.Molde_Fechado = val;
    },

    getObjMoldeAberto(val) {
      this.dados.Molde_Aberto = val;
    },
    click_vmodal() {
      this.$store.commit('setPadding', '0rem 2rem');
      this.$store.commit("SetFormPage", 0); 
      this.vmodal = true
      if (this.vmodal) {
        this.$store.commit("setHiddenBar", true); 
        document.body.classList.add('sc');
      }
    },
    async verify_tipo_injecao(molde_aberto) {
      if (
        molde_aberto.tipo_de_injecao.direta == false &&
        molde_aberto.tipo_de_injecao.indireta == false &&
        molde_aberto.tipo_de_injecao.bico_quente == false
      ) {
        return true;
      }
      return false;
    },
    incrementPage() {
       const current = this.$store.state.formPage;
       if (!this.validatePage(current)) {
         return;
       }
      this.$store.commit("increment");
    },
    decrementPage() {
      this.$store.commit('decrement');
    }
  ,
    async submitForm() {

      const LSP = this.$store.getters.$GetImagesLSP;

      if (
           !LSP ||
           Object.values(LSP).some(v => v === "" || v == null)
         ) {
           Toast.fire({ icon: "error", title: "Adicione um Spare part" });
           return false;
         }
         
      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      const verify = await this.verify_tipo_injecao(this.dados.Molde_Aberto);

      if (verify) {
        Toast.fire({
          icon: "error",
          title: "Preencher tipo de injeção obrigatório!",
        });
        return;
      }

      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) {
        Toast.fire({
          icon: "error",
          title: "Preencher todos os campos obrigatórios!",
        });
        return;
      }

      const toast = await this.$swal
        .fire({
          title: "Deseja salvar RRIM",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      await this.$store.commit("SetLoadingPattern", true); // insere o loading

      // RRIM - INFORMACAO GERAIS, PRODUTOS, MOLDE-ABERTO, MOLDE-FECHADO
      this.dados.Molde_Fechado.checklist =
        this.$store.getters.$GetDataEmitsUpdate.checklist;

      this.dados.Molde_Aberto.tipo_de_injecao.camera_quente =
        this.dados.Molde_Fechado.camera_quente.showCameraQuente;

      // POST RRIM
      const result = await PostDataAllRRIM(this.dados);

      console.log(this.dados)

      //IMAGENS
      const DataImage = this.$store.getters.$GetDataImages;
      // Abertura de Embalagem
      const formDataImages = new FormData();
      formDataImages.append(
        "IMG_EMB_EXT",
        DataImage.AberturaEmbalagem.fotoEmbalagemE
      );
      formDataImages.append(
        "IMG_EMB_INT",
        DataImage.AberturaEmbalagem.fotoEmbalagemI
      );
      formDataImages.append(
        "IMG_EMB_EXTRA",
        DataImage.AberturaEmbalagem.fotoEmbalgemExtra.file
      );

      formDataImages.append(
        "IMG_EMB_EXTRA_DESC",
        DataImage.AberturaEmbalagem.fotoEmbalgemExtra.description
      );

      //  Molde Fechado
      formDataImages.append(
        "IMG_MF_PLA_ID",
        DataImage.MoldeFechado.FotoPlaquetadeIdentificacaodomoldeFile
      );
      formDataImages.append(
        "IMG_MF_CAM_QUENTE",
        DataImage.MoldeFechado.IDdaCâmaraQuenteFile
      );
      formDataImages.append(
        "IMG_MF_L_DIREITO",
        DataImage.MoldeFechado.FotodoLadoDireitoFile
      );
      formDataImages.append(
        "IMG_MF_L_ESQUERDO",
        DataImage.MoldeFechado.FotodoLadoEsquerdoFile
      );
      formDataImages.append(
        "IMG_MF_PLA_L_MOVEL",
        DataImage.MoldeFechado.FotodaPlacadoLadoMovelFile
      );
      formDataImages.append(
        "IMG_MF_PLA_L_FIXO",
        DataImage.MoldeFechado.FotodaPlacadoLadoFixoFile
      );
      formDataImages.append(
        "IMG_MF_L_SUPERIOR",
        DataImage.MoldeFechado.FotodoLadoSuperiorFile
      );
      formDataImages.append(
        "IMG_MF_PLA_SIS_REF",
        DataImage.MoldeFechado.FotodaPlaquetadosistemadeRefrigeraçãoFile
      );

      // Molde Aberto
      formDataImages.append(
        "IMG_MA_F_L_FIXO",
        DataImage.MoldeAberto.FotodaFacedoLadoFixoFile
      );
      formDataImages.append(
        "IMG_MA_F_L_MOVEL",
        DataImage.MoldeAberto.FotodaFacedoLadoMovelFile
      );
      formDataImages.append(
        "IMG_MA_EXTRA",
        DataImage.MoldeAberto.fotoMoldeAbertoExtra.file
      );

      formDataImages.append(
        "IMG_MA_EXTRA_DESC",
        DataImage.MoldeAberto.fotoMoldeAbertoExtra.description
      );

      formDataImages.append(
        "IMAGEM_CAF",
        DataImage.CAF.file
      );
      formDataImages.append(
        "IMAGEM_CAF_DESC",
        DataImage.CAF.description
      );
      await this.$store.commit("SetLoadingPattern", false); 

      // POST FOTOS
      await PostImagesRRIM(result.data.rrim, formDataImages);
      // if (ImagesRRIM.status == 201) {
      //   Toast.fire({
      //     icon: "success",
      //     title: "Imagens RRIM salvas com sucesso.",
      //   });
      // }

      // LSP
      const DataImagesLSP = this.$store.getters.$GetImagesLSP;

      if (DataImagesLSP.length == 0) {
        // Toast.fire({
        //   icon: "success",
        //   title: "RRIM salva com sucesso.",
        // });
        // window.location.reload();
        // return;
      }

      if (DataImagesLSP) {
        if (DataImagesLSP.length > 0) {
          let formDataLSP = new FormData();
          await DataImagesLSP.map((element) => {
            formDataLSP.append("fotoEmbalagem[]", element.file);
            formDataLSP.append("descfotoEmbalagem[]", element.desc);
            formDataLSP.append("quantidadefotoEmbalagem[]", element.quantidade);
            formDataLSP.append("observacaofotoEmbalagem[]", element.observacao);
          });

          // POST LSP
          await PostDataImagesLspRRIM(result.data.rrim, formDataLSP);
        }
      }

      if (result.status == 201 || result.status == 200) {
        Toast.fire({
          icon: "success",
          title: "RRIM salva com sucesso.",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Algo deu errado no salvamento da RRIM!",
          text: "Procurar o suporte!",
        });
      }
      window.location.reload();
      this.$store.commit('setPadding', '2rem');
      return;
    },
    validatePage(page) {
      const Toast = this.$swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    switch(page) {
       case 0:
        const lengthImg = this.$store.getters.GetCAF

        if (
          !this.dados.InforGeral ||
          Object.values(this.dados.InforGeral).some(v => v === "" || v == null) || lengthImg.file.length === 0
        ) {
          Toast.fire({ icon: "error", title: "Preencha todos os campos de Informações Gerais" });
          return false;
        }
        if (!Array.isArray(this.dados.Produtos) || this.dados.Produtos.length === 0) {
          Toast.fire({ icon: "error", title: "Adicione pelo menos um produto" });
          return false;
        }
        break;

      case 1:
        
        if (
          !this.dados.Molde_Fechado ||
          Object.values(this.dados.Molde_Fechado).some(v => v === "" || v == null)
        ) {
          Toast.fire({ icon: "error", title: "Preencha todos os campos do Molde Fechado" });
          return false;
        }
        break;

      case 2:
        const list = this.$store.getters.$GetDataEmitsUpdate.checklist;; 

        if (!Array.isArray(list)) {
          Toast.fire({ icon: "error", title: "Checklist não disponível!" });
          return false;
        }

        const faltandoOpcao = list.find(item => !item.opcao);
        if (faltandoOpcao) {
          Toast.fire({ icon: "error", title: "Selecione uma opção para cada item do checklist." });
          return false;
        }

        break;
            
      case 3:

         if (
          !this.dados.Molde_Aberto ||
          Object.values(this.dados.Molde_Aberto).some(v => v === "" || v == null)
        ) {
          Toast.fire({ icon: "error", title: "Preencha todos os campos do Molde Aberto" });
          return false;
        }
        break;

      case 4:
          const imgs = this.$store.getters.$GetDataImages.AberturaEmbalagem;

        if (imgs.fotoEmbalagemE.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto externa da embalagem." });
          return false;
        }
        if (imgs.fotoEmbalagemI.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto interna da embalagem." });
          return false;
        }
        // if (!imgs.fotoEmbalgemExtra ||
        //     !imgs.fotoEmbalgemExtra.file ||
        //     !imgs.fotoEmbalgemExtra.description
        // ) {
        //   Toast.fire({
        //     icon: "error",
        //     title: "Envie a foto extra da embalagem e seu título."
        //   });
        //   return false;
        // }
        break;

      case 5:
          const imgs1 = this.$store.getters.$GetDataImages.MoldeFechado;

        if (imgs1.FotoPlaquetadeIdentificacaodomoldeFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto da Plaqueta de Identificação do Molde." });
          return false;
        }
        if (imgs1.IDdaCâmaraQuenteFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto do id da câmara quente." });
          return false;
        }

        if (imgs1.FotodoLadoDireitoFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto do lado direito." });
          return false;
        }

        if (imgs1.FotodoLadoEsquerdoFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto do lado esquerdo." });
          return false;
        }
      
        if (imgs1.FotodaPlacadoLadoMovelFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto da placa do lado móvel." });
          return false;
        }

        if (imgs1.FotodaPlacadoLadoMovelFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto da placa do lado móvel." });
          return false;
        }

        if (imgs1.FotodaPlacadoLadoFixoFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto da placa do lado fixo." });
          return false;
        }

        if (imgs1.FotodoLadoSuperiorFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto do lado superior." });
          return false;
        }

        if (imgs1.FotodaPlaquetadosistemadeRefrigeraçãoFile.length == 0) {
          Toast.fire({ icon: "error", title: "Envie a foto da plaqueta do sistema de refrigeração." });
          return false;
        }

        break;

      case 6:
           const imgs2 = this.$store.getters.$GetDataImages.MoldeAberto;

         if (imgs2.FotodaFacedoLadoFixoFile.length == 0) {
           Toast.fire({ icon: "error", title: "Envie a foto da face do lado fixo." });
           return false;
         }
         if (imgs2.FotodaFacedoLadoMovelFile.length == 0) {
           Toast.fire({ icon: "error", title: "Envie a foto da face do lado movél." });
           return false;
         }
        //  if (!imgs2.fotoMoldeAbertoExtra ||
        //      !imgs2.fotoMoldeAbertoExtra.file ||
        //      !imgs2.fotoMoldeAbertoExtra.description
        //  ) {
        //    Toast.fire({
        //      icon: "error",
        //      title: "Envie a foto extra da embalagem e seu título."
        //    });
        //    return false;
        //  }
         break;

      default:
        // páginas extras (se houver)
        break;
    }

    return true;
    }
  },
   computed: {
     imagetest() {
       return this.$store.state.DataImagesLSP;
     }
   }
};
</script>


<style scoped>

::placeholder {
    font-weight: 400;
    color: red!important;
}

.blurringbackground {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(3px); 
    transition: opacity 0.3s ease, visibility 0.3s ease;
    visibility: hidden;
    opacity: 0;
  }

  
  .blurringbackground.show {
      visibility: visible;
      opacity: 1;
    }
    
.btnModalRRIM {
  display: flex;
  align-items: center!important;
  justify-content: left;
  padding: 1rem 1rem 1rem 0rem;
}


.buttonsubtittle {
  font-family: Poppins, sans-serif;
  margin-left: 0.4rem;
  font-weight: 400!important;
}

.modal-body {
  width: 100%;
  overflow-y: auto; 

}

.tab-content {
  display: flex;
  justify-content: center;
}

.card_end {
  justify-content: flex-end;
  display: flex;
}
.flex {
  display: flex!important;
  flex-direction: row!important;
  align-items: center;
  justify-content: space-between;
  width: 100%!important;
}


.title_modal {
  width: 100%!important;
  padding: 1rem 2.5rem 0rem!important;
}

.close_button{
  background-image: url("../../../static/icons/close_iconblack.svg");
  background-repeat: no-repeat;
  background-size: 70%;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem; 
  background-color: rgba(255, 0, 0, 0);
  border-radius: 50%; 
  display: inline-block; 
  transition: background-color 0.3s ease; 
  transition: outline 0.3s ease; 
}

.close_button:hover{
  background-color: var(--gray);
  outline: 6px solid var(--gray);
}

.title_modal input {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.title_modal input:hover {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.modal_mask {
  position: fixed;
  display: block;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: auto;
}

.modal_mask {
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes growIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1); 
  }
}

@keyframes growOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Estado inicial ao abrir e estado final ao fechar */
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.modal_mask .modal_content {
  position: relative;
  width: auto;
  max-height: calc(100vh - 2rem);
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  box-shadow: 4px 4px 5px rgba(75, 74, 74, 0.5); 
  flex-direction: column;
  transition: 1.2s;
  align-items: center;
  opacity: 0; 
  transform: scale(0.8); 
  animation: growIn 0.15s ease-out forwards; 
}

.closing {
  transform: scale(0.8); 
  animation: growOut 0.3s ease-in forwards;
}

.modal_mask .modal_content .modal_header {
  width: 100%;
  height: 4.5rem;
  line-height: 3.5rem;
  background: white !important;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.modal_mask .modal_content .modal_header .title_modal {
  width: 90%;
  margin: auto;
  color: var(--font_color);
  
  font-size: 1.5rem;
  text-align: start;
  align-items: center;
  justify-content: space-between;
}

h4 {
  font-family: 'Poppins', sans-serif!important;
  font-weight: 600!important;
  font-size: 1.7rem;

}

.column_1 {
  overflow-y: scroll;
}

.column_2 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.modal_mask .modal_body {
  width: 98%;
  /* height: 90%; */
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
  /* overflow-y: scroll; */
  padding: 0 15px;
  display: grid;
  gap: 1vw;
  grid-template-columns: 3.7fr 1fr;
}

.modal_mask .modal_body .cards {
  width: 100%;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  text-align: start;
}

.modal_mask .modal_body .cards .card_informations {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--white);
  padding: 20px;
  border-radius: 10px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.font-weight-bold {
  font-weight: 700 !important;
}

.mx-3 {
  margin-left: 1rem !important;
}

.modal_mask .modal_body .cards .card_informations .title {
  width: 100%;
  color: var(--green);
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--white);
  background-color: var(--green);
}

.modal_mask .modal_body .button_modal {
  width: 100%;
  position: relative;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: flex-end;
  padding: 25px;
  justify-items: end;
  display: flex;
}

.table-content {
  overflow-y: scroll;
  /* height: 20
rem
; */
  height: 80vh;
}

.card-header {
  width: 100%;
  padding: 0.75rem 1.25rem 0 1.25rem;
  margin-bottom: 0;
  background-color: #f8f8f8;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs .nav-link.active {
  color: var(--greyBtn);
  background-color: var(--white);
  border-color: #dddfeb #dddfeb #fff;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}
.text-success {
  color: var(--green) !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
a {
  color: var(--green);
  text-decoration: none;
  background-color: transparent;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.modal-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: center;
  justify-content: flex-end;
  padding: 1.3rem 0.75rem;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.modal-footer button {
  cursor: pointer;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

@media (max-width: 1266px) {
  .modal_mask .modal_content {
    width: 80%;
  }
}

@media (max-width: 413px) {
  h4 {
    font-size: 1.1rem;
  }
}

@media (max-width: 400px) {
  .modal_mask .modal_content {
    width: 90%;
    
  }

  .btnModalRRIM {
    width: 100%;
  }

}


</style>
